import * as Elements from "./element-types/index.js";
import {CountrySelectorElement} from "./element-types/index.js";

/**
 * Factory function to create and return a class reference for a specific form element type.
 *
 * @param {Object} elementConfiguration - An object containing configuration for the form element.
 * @param {string} elementConfiguration.type - The type of the element to be created (e.g., text, select, area, etc.).
 * @return {Function} The constructor function for the specified element type.
 * @throws {Error} Throws an error if the specified element type is not supported.
 */
export function elementFactory(elementConfiguration) {
    const elementConstructors = {
        text: Elements.TextElement,
        select: Elements.SelectElement,
        area: Elements.AreaElement,
        multiselect: Elements.MultiSelectElement,
        checkbox: Elements.CheckElement,
        boolean: Elements.CheckElement,
        radiogroup: Elements.RadioGroupElement,
        spacer: Elements.FormElement,
        section: Elements.SectionElement,
        intlphone: Elements.IntlPhoneElement,
        countrypicker: Elements.CountrySelectorElement,
        hidden: Elements.HiddenElement
    };

    const elementType = elementConfiguration.type.toLowerCase();
    const elementClass = elementConstructors[elementType];

    if (!elementClass) {
        throw new Error(`Element type ${elementConfiguration.type} not supported`);
    }

    return elementClass;
}